/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to convert a lead to a natural person
 * @export
 * @interface ConvertLeadToPersonCommand
 */
export interface ConvertLeadToPersonCommand {
    /**
     * The unique identifier of the lead to convert
     * @type {string}
     * @memberof ConvertLeadToPersonCommand
     */
    leadId: string;
    /**
     * The unique identifier of the broker to assign the person to
     * @type {string}
     * @memberof ConvertLeadToPersonCommand
     */
    brokerId: string;
}

/**
 * Check if a given object implements the ConvertLeadToPersonCommand interface.
 */
export function instanceOfConvertLeadToPersonCommand(value: object): value is ConvertLeadToPersonCommand {
    if (!('leadId' in value) || value['leadId'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    return true;
}

export function ConvertLeadToPersonCommandFromJSON(json: any): ConvertLeadToPersonCommand {
    return ConvertLeadToPersonCommandFromJSONTyped(json, false);
}

export function ConvertLeadToPersonCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConvertLeadToPersonCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'leadId': json['leadId'],
        'brokerId': json['brokerId'],
    };
}

export function ConvertLeadToPersonCommandToJSON(json: any): ConvertLeadToPersonCommand {
    return ConvertLeadToPersonCommandToJSONTyped(json, false);
}

export function ConvertLeadToPersonCommandToJSONTyped(value?: ConvertLeadToPersonCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leadId': value['leadId'],
        'brokerId': value['brokerId'],
    };
}

